import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLock = () => {
  return (
    <g>
      <path d="M8.002 0a4.01 4.01 0 0 1 3.993 3.811l.005.2v1.997l1.951.004c.541 0 .986.41 1.043.936l.006.114v7.887c0 .542-.41.988-.936 1.045L13.95 16H2.05a1.05 1.05 0 0 1-1.044-.936L1 14.949V7.046c0-.542.41-.988.936-1.045l.114-.006L4 5.997V3.993A3.993 3.993 0 0 1 7.792.005L8.002 0zM2.5 7.496V14.5h11V7.511l-11-.015zM8 8.984a.75.75 0 0 1 .743.649l.007.102v2.503a.75.75 0 0 1-1.493.102l-.007-.102V9.735a.75.75 0 0 1 .75-.75zm0-7.483A2.494 2.494 0 0 0 5.505 3.83l-.005.163V6l5 .007V4.011a2.51 2.51 0 0 0-2.336-2.504L8 1.5z" />
    </g>
  );
};

export default withIcon(IconLock);
